<template>
  <modal-padrao
    ref="modal"
    titulo-modal="CRONOGRAMA DE ETAPAS"
    :btn-salvar="btnSalvar"
    :btn-excluir="btnExcluir"
    @ok="salvar"
    @excluir="remover"
    @cancelar="fecharModal"
  >
    <div class="row" v-if="form">
      <input-text
        class="col-2"
        label="Nº etapa"
        disabled
        v-model="numeroCalculado"
      />
      <input-text
        class="col-10 col-md-6"
        label="Titulo da etapa"
        v-model="form.etapa.tituloDaEtapa"
      />
      <input-select
        class="col-12 col-md-2"
        label="Mês inicial"
        :options="mesesDepesas"
        v-model="form.etapa.mesInicial"
        ref="mesInicial"
        required
      />
      <input-select
        class="col-12 col-md-2"
        label="Mês final"
        :options="mesesDepesas"
        v-model="form.etapa.mesFinal"
        ref="mesFinal"
        required
      />

      <template v-for="subetapa in form.subetapas">
        <div class="col-12" :key="subetapa.subetapaId">
          <div class="row">
            <input-text
              class="col-2"
              label="Nº subetapa"
              readonly
              v-model="subetapa.numero"
            >
              <template #prepend>
                <div class="d-flex">
                  <b-button
                    variant="flat-danger"
                    v-if="
                      !TelaProponente &&
                      !TelaProponenteCooperada &&
                      !TelaExecAssociada
                    "
                    class="mr-2"
                    @click="removeSubetapa(subetapa)"
                    ><i class="fas fa-trash"></i
                  ></b-button>
                </div>
              </template>
            </input-text>
            <input-text
              class="col-11 col-md-6"
              label="Titulo da subetapa"
              v-model="subetapa.tituloDaEtapa"
            />
            <input-select
              class="col-12 col-md-2"
              label="Mês inicial"
              :options="mesesDepesas"
              v-model="subetapa.mesInicial"
              ref="mesInicial"
              required
            />
            <input-select
              class="col-12 col-md-2"
              label="Mês final"
              :options="mesesDepesas"
              v-model="subetapa.mesFinal"
              ref="mesFinal"
              required
            />
          </div>
        </div>
      </template>

      <div class="col-12 mb-4">
        <b-button
          v-if="
            !TelaProponente && !TelaProponenteCooperada && !TelaExecAssociada
          "
          variant="info"
          size="sm"
          @click="addSubetapa()"
        >
          <b-icon icon="plus-circle-fill" class="mr-2" />
          Adicionar subtema
        </b-button>
      </div>

      <input-textarea
        class="col-12"
        label="Detalhamento"
        v-model="form.detalhamento"
      />

      <template v-for="relatorio in form.relatoriosEtapas">
        <div class="col-12" :key="relatorio.relatorioId">
          <div class="row">
            <input-text
              class="col-2"
              label="Nº relatório"
              readonly
              v-model="relatorio.numero"
            >
              <template #prepend>
                <div
                  class="d-flex"
                  v-if="!TelaProponente && !TelaProponenteCooperada"
                >
                  <b-button
                    variant="flat-danger"
                    class="mr-2"
                    @click="removeRelatorio(relatorio)"
                    ><i class="fas fa-trash"></i
                  ></b-button>
                </div>
              </template>
            </input-text>
            <input-text
              class="col-10 col-md-8"
              label="Titulo do relatório"
              v-model="relatorio.titulo"
            />
            <input-select
              class="col-12 col-md-2"
              label="Mês final"
              :options="mesesDepesas"
              v-model="relatorio.mesFinal"
              ref="mesFinal"
              required
            />
          </div>
        </div>
      </template>
      <div class="col-12 mb-4">
        <b-button
          v-if="!TelaProponente && !TelaProponenteCooperada"
          variant="info"
          size="sm"
          @click="addRelatorio()"
        >
          <b-icon icon="plus-circle-fill" class="mr-2" />
          Adicionar relatório
        </b-button>
      </div>
    </div>
  </modal-padrao>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputTextarea from "@/components/inputs/InputTextarea";
import InputText from "@/components/inputs/InputText";

import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import PropostaService from "@/common/services/proposta/proposta.service";
import cloneDeep from "lodash.clonedeep";

export default {
  name: "ModalCronograma",
  components: {
    InputSelect,
    InputTextarea,
    InputText,
  },
  data: function () {
    return {
      form: null,
      duracao: 0,
      numeroEtapa: 0,
      endpoint: "Proposta",
      propostaId: null,
      btnExcluir: false,
      btnSalvar: true,
    };
  },
  methods: {
    abrirModal: function (
      duracao,
      propostaId,
      numeroEtapa = 0,
      endpoint = "Proposta",
      form = {
        cronogramaEtapaId: null,
        etapa: {
          etapaId: null,
          numero: null,
          tituloDaEtapa: null,
          mesInicial: null,
          mesFinal: null,
        },
        subetapas: [],
        detalhamento: null,
        relatoriosEtapas: [],
      },
      btnExcluir = false,
      btnSalvar = true
    ) {
      this.form = form;
      this.duracao = duracao;
      this.propostaId = propostaId;
      this.numeroEtapa = numeroEtapa;
      this.endpoint = endpoint;
      this.btnExcluir = btnExcluir;
      this.btnSalvar = btnSalvar;
      this.$refs.modal.abrirModal();
    },

    fecharModal: function () {
      this.$emit("buscar");
      this.$refs.modal.fecharModal();
    },

    salvar: function () {
      this.confirmar("Deseja salvar etapa?").then((confirmado) => {
        if (!confirmado) return;

        if (!this.validarFormulario()) return;

        this.$store.dispatch(START_LOADING);

        let form = cloneDeep(this.form);
        form.propostaId = this.propostaId;
        form.propostaEmpresaExecutoraId = this.propostaId;

        let deuErro = false;

        if (this.TelaExecAssociada) {
          let novoForm = cloneDeep(form);
          novoForm.relatoriosEtapas = this.form.relatoriosEtapas.filter(
            (s) => !s.id
          );
          PropostaService.salvarEtapa(novoForm, true).catch(() => {
            deuErro = true;
            this.alertaErro("Erro ao salvar etapa");
          });
        }

        if (deuErro) return;

        PropostaService.salvarEtapa(form)
          .then(() => {
            this.alertaSucesso("Etapa salva com sucesso").then(() => {
              this.fecharModal();
            });
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.alertaErro(`${err.response.data.errors}`);
            } else {
              this.alertaErro("Erro ao salvar etapa");
            }
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    remover: function () {
      let item = cloneDeep(this.form);

      this.confirmar("Deseja remover etapa?").then((confirmado) => {
        if (!confirmado) return;

        let form = {
          cronogramaEtapaId: item.id,
          propostaId: this.propostaId,
        };

        this.$store.dispatch(START_LOADING);

        PropostaService.removerEtapa(form)
          .then(() => {
            this.alertaSucesso("Etapa removida com sucesso").then(() => {
              this.fecharModal();
            });
          })
          .catch(() => {
            this.alertaErro("Erro ao remover etapa");
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    addSubetapa: function () {
      let numero =
        this.form.subetapas.length == 0
          ? 1
          : parseInt(
              this.form.subetapas[
                this.form.subetapas.length - 1
              ].numero.substring(
                this.form.subetapas[
                  this.form.subetapas.length - 1
                ].numero.indexOf(".") + 1
              )
            ) + 1;

      this.form.subetapas.push({
        subetapaId: null,
        numero: `${this.numeroCalculado}.${numero}`,
        tituloDaEtapa: null,
        mesInicial: null,
        mesFinal: null,
      });
    },

    removeSubetapa: function (subetapa) {
      this.form.subetapas.splice(this.form.subetapas.indexOf(subetapa), 1);
    },

    addRelatorio: function () {
      let numero;
      if (this.form.relatoriosEtapas.length === 0) {
        numero = this.numeroCalculado;
      } else {
        const ultimoRelatorio =
          this.form.relatoriosEtapas[this.form.relatoriosEtapas.length - 1];
        const ultimoNumero = ultimoRelatorio.numero;

        if (typeof ultimoNumero === "number") {
          numero = ultimoNumero + 1;
        } else {
          const numeroSeparado = ultimoNumero.split(".");
          const sufixoAtual = numeroSeparado[1];

          if (!sufixoAtual) {
            numero = `${numeroSeparado[0]}.a`;
          } else {
            const proximoSufixo = String.fromCharCode(
              sufixoAtual.charCodeAt(0) + 1
            );

            if (proximoSufixo > "z") {
              numero = ultimoNumero;
            } else {
              numero = `${numeroSeparado[0]}.${proximoSufixo}`;
            }
          }
        }
      }
      this.form.relatoriosEtapas.push({
        relatorioId: null,
        numero: numero,
        titulo: "RELATÓRIO DE ETAPA",
        mesFinal: null,
      });
    },

    removerRelatorio: function (relatorio) {
      if (!this.TelaExecAssociada) {
        this.form.relatoriosEtapas.splice(
          this.form.relatoriosEtapas.indexOf(relatorio),
          1
        );
        return;
      }

      this.confirmar("Alerta", "Deseja realmente remover este relatório?").then(
        (confirmado) => {
          if (!confirmado) return;
          let form = {
            relatorioEtapaId: relatorio.id,
            cronogramaEtapaId: this.form.id,
            propostaId: this.propostaId,
            propostaEmpresaExecutoraId: this.propostaId,
          };

          this.$store.dispatch(START_LOADING);

          PropostaService.removerEtapa(form)
            .then(() => {
              this.form.relatoriosEtapas.splice(
                this.form.relatoriosEtapas.indexOf(relatorio),
                1
              );
              this.alertaSucesso("Relatório excluído com sucesso");
            })
            .catch(() => {
              this.alertaErro("Erro ao excluir relatório");
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      );
    },
    removeRelatorio: function (relatorio) {
      if (this.TelaExecAssociada) {
        this.confirmar(
          "Alerta",
          "Deseja realmente remover este relatório?"
        ).then((v) => {
          if (v) {
            this.$emit("removerRelatorio", relatorio);
            this.form.relatoriosEtapas.splice(
              this.form.relatoriosEtapas.indexOf(relatorio),
              1
            );
          }
        });
      } else
        this.form.relatoriosEtapas.splice(
          this.form.relatoriosEtapas.indexOf(relatorio),
          1
        );
    },
  },
  computed: {
    mesesDepesas() {
      return helpers.criarArrayMes(`2022-01-01`, this.duracao, true);
    },

    numeroCalculado: {
      get: function () {
        if (this.form == null) return 0;
        return this.form.etapa.numero
          ? this.form.etapa.numero
          : this.numeroEtapa;
      },

      set: function (value) {
        this.form.etapa.numero = value;
      },
    },

    TelaProponente() {
      return this.endpoint == "PropostaEmpresaProponente";
    },
    TelaExecAssociada() {
      return this.endpoint == "PropostaEmpresaExecutora";
    },
    TelaProponenteCooperada() {
      return this.endpoint == "PropostaEmpresaCooperada";
    },
  },
  watch: {
    numeroCalculado: {
      handler: function () {
        this.form.etapa.numero = this.numeroCalculado;
      },
    },
  },
};
</script>
<style lang=""></style>
